import { render } from "./AddConfigurationsToListModal.vue?vue&type=template&id=c8a300ca"
import script from "./AddConfigurationsToListModal.vue?vue&type=script&lang=js"
export * from "./AddConfigurationsToListModal.vue?vue&type=script&lang=js"

import "./AddConfigurationsToListModal.vue?vue&type=style&index=0&id=c8a300ca&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__